import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';
import { CardHeader } from '../../../dataDisplay/Card/CardHeader.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var StyledCardHeader = styled(CardHeader).withConfig({
  displayName: "StyledCardHeader",
  componentId: "sc-kl54og-0"
})([""]);
function DialogHeader(props) {
  var children = props.children,
    restProps = __rest(props, ["children"]);
  return /*#__PURE__*/jsx(StyledCardHeader, _extends({}, restProps, {
    children: children
  }));
}

export { DialogHeader, StyledCardHeader };
